import BaseService from './base.service';

export default class ConfirmTokenService extends BaseService {
  confirmToken(token) {
    return this.post(`/confirm-token`, { token });
  }
}
